<template>
  <div class="password-page-container">
    <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background-color: transparent;" :title="type == 1 ? $t('修改登录密码') : $t('设置提现密码')" left-arrow @click-left="$router.back()" />
    <div style="height: 46px; flex-shrink: 0;"></div>
    <div class="content">
      <div class="usrse">
        <div class="hgs">
          <div class="nams">{{ $t('原密码') }}</div>
          <input v-model="passwordInfo.password" type="password" :placeholder="$t('请输入当前密码')">
        </div>
        <div class="hgs">
          <div class="nams">{{ $t('新密码') }}</div>
          <input v-model="passwordInfo.paypassword" type="password" :placeholder="$t('请输入新密码')">
        </div>
        <div class="hgs">
          <div class="nams">{{ $t('确认新密码') }}</div>
          <input v-model="passwordInfo.newpasword" type="password" :placeholder="$t('请再次输入密码')">
        </div>
        <div class="submit" @click="editPassword(type)">{{ $t('确认修改') }}</div>
        <div style="height: 60px"></div>
      </div>
    </div>
  </div>
</template>
<script>
import {translateText} from "../common/utils";

export default {
  name: 'password',
  data() {
    return {
      passwordInfo: {},
      type: 1,
      psw1: true,
      psw2: true,
      psw3: true,
    };
  },
  created() {
    let that = this;
    let query = that.$route.query;

    if (query.type) {
      that.type = query.type * 1;
    }
  },
  methods: {
    async showTost(type = 0, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    changPsw(name) {
      this[name] = !this[name];
    },
    changtab() {
      let that = this;
      that.passwordInfo = {};
      that.info = {};
    },
    editPassword(pasType) {
      let that = this;
      if (!that.passwordInfo.password) {
        that.$parent.showTost(0, that.$t('请输入旧密码'));
        return;
      }
      if (!that.passwordInfo.paypassword) {
        that.$parent.showTost(0, that.$t('请输入新密码'));
        return;
      }
      if (that.passwordInfo.password.length < 6) {
        that.$parent.showTost(0, that.$t('请输入正确的旧密码长度'));
        return;
      }
      if (that.passwordInfo.paypassword.length < 6) {
        that.$parent.showTost(0, that.$t('请输入正确的新密码长度'));
        return;
      }
      if (!that.passwordInfo.newpasword) {
        that.$parent.showTost(0, that.$t('请输入确认密码'));
        return;
      }
      if (that.passwordInfo.newpasword != that.passwordInfo.paypassword) {
        that.$parent.showTost(0, that.$t('两次密码不一致') + '！');
        return;
      }
      if (that.passwordInfo.password == that.passwordInfo.paypassword) {
        that.$parent.showTost(0, that.$t('新旧密码不能一致') + '！');
        that.passwordInfo = {};
        return;
      }
      let url = pasType == 1 ? '/api/editPassword' : '/api/editPayPassword';

      that.$parent.showLoading();
      that.$apiFun.post(url, {paypassword:that.passwordInfo.paypassword,password:that.passwordInfo.password}).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        that.$parent.hideLoading();
        if (res.code == 200) {
          that.$parent.showTost(1, that.$t('密码修改成功') + '！');
          that.passwordInfo = {};
          if (pasType == 1) {
            that.$parent.closeDaoTime();
            localStorage.clear();
            sessionStorage.clear();
            that.$store.commit('changUserInfo');
            that.$store.commit('changToken');
            that.$router.push({ path: '/login' });
          }
        }
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss">
.password-page-container {
  .van-nav-bar__title {
    color: #fff !important;
    font-size: 0.48rem;
  }
  .van-nav-bar .van-icon {
    color: #fff !important;
    font-size: 0.48rem;
  }
}
</style>
<style lang="scss" scoped>
.password-page-container {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #000;
  color: #fff;
  font-family: PingFang SC;
  background-image: url("/static/image/new/page-bg-img.png");
  background-size: cover;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .content {
    flex: 1;
    overflow: auto;
    padding: 0.2rem .4rem;
  }
  .usrse {
    box-sizing: border-box;
    .hgs {
      display: flex;
      align-items: center;
      background: rgba(255, 255, 255, 0.10);
      border: 0.03rem solid rgba(255, 255, 255, 0.10);
      border-radius: .21rem;
      margin-bottom: .27rem;
      height: 1.49rem;
      padding: 0 .27rem;
      .nams {
        font-size: 0.37rem;
        vertical-align: middle;
        font-weight: 600;
        width: 3rem;
        flex-shrink: 0;
      }
      input {
        flex: 1;
        text-align: right;
        outline: none;
        border: none;
        background: transparent;
      }
      input:-webkit-autofill,
      input:-webkit-autofill:hover,
      input:-webkit-autofill:focus {
        -webkit-box-shadow: 0 0 0px 1000px #1B1B1B inset !important;
        box-shadow: 0 0 0px 1000px #1B1B1B inset !important;
        -webkit-text-fill-color: #fff !important; /* 保持文本颜色继承 */
        transition: background-color 9999s ease-out 0s !important;
      }

    }

    .submit {
      height: 1.17rem;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(180deg, #4B5BF1, #B5BBF8);
      margin-top: .53rem;
      font-size: 0.43rem;
      font-weight: bold;
      border-radius: .6rem;
    }
  }
  [class*='van-hairline']:after {
    border: none;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/password.vue